import React from "react";
import { PageBuilderPageMosaicFragment } from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import SanityPageCard from "components/Card/SanityPageCard";

import { graphql } from "gatsby";
import { isPresent } from "src/utils/checks";
import {
  MosaicLayout,
  MosaicLayoutVariantType,
  cardImageRatioForMosaicIndex
} from "@silversea-ssc/ui-components-react";

export type PageBuilderPageMosaicProps = PageBuilderPageMosaicFragment;

const PageBuilderPageMosaic: React.FC<PageBuilderPageMosaicProps> = ({
  heading,
  items = [],
  mosaicVariant
}) => {
  const filteredItems = items.filter(isPresent);
  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      <MosaicLayout
        variant={mosaicVariant as MosaicLayoutVariantType}
        data-content-name="page_mosaic"
      >
        {filteredItems.map((item, index) => {
          const cardRatio = cardImageRatioForMosaicIndex(
            mosaicVariant as MosaicLayoutVariantType,
            index
          );
          return (
            <SanityPageCard
              key={item.id}
              page={item}
              imageRatio={cardRatio}
              cardBackgroundColor="white"
            />
          );
        })}
      </MosaicLayout>
    </React.Fragment>
  );
};

export default PageBuilderPageMosaic;

export const fragments = graphql`
  fragment PageBuilderPageMosaic on SanityPageMosaic {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    mosaicVariant
    items {
      ...PageAsCard
    }
  }
`;
